import { gql } from 'graphql-tag';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

const getEvaluaciones = gql`
  query Query($idPlantilla: Int) {
    evaluaciones(idPlantilla: $idPlantilla) {
      id
      fechaContable
      idPlantilla
      idInstitucion
    }
  }
`;
const getDetalleIndicadores = gql`
  query Query($idEvaluacion: Int) {
    detalleEvaluacionIndicadors(idEvaluacion: $idEvaluacion) {
      idEvaluacion
      idIndicador
      textoSemaforo
      valor
    }
  }
`;
const getDetalleIndicador = gql`
  query Query($idEvaluacion: Int!, $idIndicador: String!) {
    detalleEvaluacionIndicador(idEvaluacion: $idEvaluacion, idIndicador: $idIndicador) {
      valor
      idEvaluacion
    }
  }
`;
const getIndicadores = gql`
  query Query($idPlantilla: Int) {
    indicadores(idPlantilla: $idPlantilla) {
      r0OpComparacion1
      r0OpComparacion2
      r0OpComparacion3
      r0OpComparacion4
      r0OpLogico1
      r0OpLogico2
      r0OpLogico3
      r0Valor1
      r0Valor2
      r0Valor3
      r0Valor4
      r1OpComparacion1
      r1OpComparacion2
      r1OpComparacion3
      r1OpComparacion4
      r1OpLogico1
      r1OpLogico2
      r1OpLogico3
      r0Usar
      r1Valor1
      r1Valor2
      r1Valor3
      r1Valor4
      r1Usar
      r2OpComparacion1
      r2OpComparacion2
      r2OpComparacion3
      r2OpComparacion4
      r2OpLogico1
      r2OpLogico2
      r2OpLogico3
      r2Valor1
      r2Valor2
      r2Valor3
      r2Valor4
      r2Usar
      r3OpComparacion1
      r3OpComparacion2
      r3OpComparacion3
      r3OpComparacion4
      r3OpLogico1
      r3OpLogico2
      r3OpLogico3
      r3Valor1
      r3Valor2
      r3Valor3
      r3Valor4
      r3Usar
      r4OpComparacion1
      r4OpComparacion2
      r4OpComparacion3
      r4OpComparacion4
      r4OpLogico1
      r4OpLogico2
      r4Oplogico3
      r4Valor1
      r4Valor2
      r4Valor3
      r4Valor4
      r4Usar
      r5OpComparacion1
      r5OpComparacion2
      r5OpComparacion3
      r5OpComparacion4
      r5Oplogico1
      r5Oplogico2
      r5Oplogico3
      r5Valor1
      r5Valor2
      r5Valor3
      r5Valor4
      r5Usar
      id
      idPlantilla
      nivel
      formula
      descripcion
      comentario
    }
  }
`;
export { getEvaluaciones, getDetalleIndicadores, getDetalleIndicador, getIndicadores }